import { Action, createAction } from 'redux-actions';
import { SelectedFare } from '../../../DesktopFlight/types';

export const ADD_SELECTED_FARE = 'ADD_SELECTED_FARE';
export const SLICE_SELECTED_FARES = 'SLICE_SELECTED_FARES';

export type SelectedFareAction = Action<SelectedFare>;
export type SliceSelectedFaresAction = Action<number>;

export const addSelectedFare = createAction(ADD_SELECTED_FARE, (fare: SelectedFare) => fare);
export const sliceSelectedFares = createAction(SLICE_SELECTED_FARES, (legId: number) => legId);
